<template>
  <!-- 添加问题弹窗 -->
  <el-dialog title="" :visible.sync="visible" class="add-question-dialog-components" :close-on-click-modal="false" :before-close="close" :show-close="true" width="500px">
    <div slot="title" class="title">添加问题</div>
    <div class="content">
      <div class="padding-b-20">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="预设问题" prop="title">
            <el-input style="width: 300px" size="small" maxlength="16" v-model="ruleForm.title" placeholder="请输入问题（16字内），ex，主队能获胜吗？ "></el-input>
          </el-form-item>
          <el-form-item label="A选项" prop="item1">
            <el-input style="width: 300px" size="small" maxlength="8" v-model="ruleForm.item1" placeholder="A选项（8字内）ex，能"></el-input>
          </el-form-item>
          <el-form-item label="B选项" prop="item2">
            <el-input style="width: 300px" size="small" maxlength="8" v-model="ruleForm.item2" placeholder="B选项（8字内）ex，不能"></el-input>
          </el-form-item>

          <el-form-item label="直播分类" prop="category">
            <el-select style="width: 300px" size="small" v-model="ruleForm.category" placeholder="请选择" @change="ChangeCategory">
              <el-option v-for="item in category" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="ruleForm.category" label="二级分类" prop="region">
            <el-select style="width: 300px" size="small" v-model="ruleForm.region" placeholder="请选择二级分类" @change="handChone">
              <el-option v-for="item in categorys" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="赛事选择" prop="match" v-if="ruleForm.category == 2">
            <el-select style="width: 300px" size="small" v-model="ruleForm.match" filterable placeholder="请选择赛事" @change="selectMatch">
              <el-option v-for="(item, index) in MatchComp" :key="index" :label="item.comp" :value="item.comp"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场次选择" prop="session" v-if="ruleForm.category == 2">
            <el-select style="width: 300px" size="small" v-model="ruleForm.session" placeholder="请选择场次" @change="chooseSession">
              <el-option v-for="(item, index) in dateMatch" :key="index" :label="item.home ? `${item.home}-${item.away}` : ''" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="关联直播" prop="match_id">
            <el-select style="width: 300px" size="small" @change="changeMatch" filterable v-model="ruleForm.match_id" placeholder="请选择">
              <el-option :label="`${item.match_event_title} ${item.home_team_name} vs ${item.away_team_name}`" v-for="item in pendingMatch" :value="item.match_id" :key="item.match_id"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="最小投注额" prop="min_bet">
            <el-select style="width: 300px" size="small" filterable v-model="ruleForm.min_bet" placeholder="请选择">
              <el-option :label="item.amount" v-for="(item, index) in moneyList" :value="item.amount" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="flex-middle">
          <div class="content-btn flex-middle" @click="commit">确定</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { dayCount } from "@/util/time";
import { mapState, mapMutations } from "vuex";
import { post } from "../../util/http";
export default {
  computed: {
    ...mapState(["userInfo", "appConfig", "chips"]),
    moneyList() {
      return [...this.chips];
    },
    categorys() {
      if (this.ruleForm.category) {
        let regionList = this.category.find((item) => item.id === this.ruleForm.category);
        return (regionList && regionList.second_category) || [];
      } else {
        return [];
      }
    },
  },

  data() {
    return {
      date: "",
      visible: false,
      pendingMatch: [],
      match: {},
      ruleForm: {
        title: "",
        item1: "",
        item2: "",
        match_id: 0,
        min_bet: "",
        category: "",
        region: "",
        match: "",
        session: "",
      },
      rules: {
        title: [{ required: true, message: "请输入问题", trigger: "change" }],
        item1: [{ required: true, message: "请输入A选项", trigger: "change" }],
        item2: [{ required: true, message: "请输入B选项", trigger: "change" }],
        match_id: [{ required: true, message: "请选择直播", trigger: "change" }],
        min_bet: [{ required: true, message: "请输入最小投注", trigger: "change" }],
        category: [{ required: true, message: "选择类型", trigger: "change" }],
        region: [{ required: true, message: "请选择二级分类", trigger: "change" }],
        match: [{ required: true, message: "请选择赛事", trigger: "change" }],
        session: [{ required: true, message: "请选择场次", trigger: "change" }],
      },
      commitStatus: false, // 提交状态：true提交中   flase未提交中
      sportId: 1,
      category: [],
      MatchComp: [],
      dateMatch: [],
    };
  },
  created() {
    this.date = dayCount(0);
  },
  destroyed() {},
  methods: {
    open() {
      this.date = dayCount(0);
      this.visible = true;
      this.inquireMatch();
    },
    close() {
      this.$refs.ruleForm.resetFields();
      this.commitStatus = false;
      this.match = {};
      this.pendingMatch = [];
      this.pageStatus = 1;
      this.visible = false;
    },
    ChangeCategory(e) {
      // 通过切换直播分类获取
      this.ruleForm.region = "";
      this.ruleForm.match = "";
      this.ruleForm.session = "";
      this.ruleForm.category = e;
    },
    handChone(e) {
      this.ruleForm.match = "";
      this.ruleForm.session = "";
      this.sportId = e;
      this.getSportMatchComp(e);
    },
    selectMatch(e) {
      this.ruleForm.session = "";
      this.ruleForm.match = e;
      this.getSportMatch(e);
    },
    chooseSession(e) {
      console.log(e, "session");
      this.ruleForm.match_id = e.match_id;
      this.ruleForm.session = `${e.home}-${e.away}`;
    },
    getSportMatch(comp) {
      post({
        url: "/api/match/getSportMatch",
        data: {
          comp: comp,
          sport_id: this.sportId,
        },
      }).then((result) => {
        if (result.status === 200) {
          console.log("getSportMatch", result);
          const res = result.data || {};
          if (res.status === 0) {
            this.dateMatch = res.data?.sport_live_match;
          }
        }
      });
    },
    getSportMatchComp(sportId) {
      post({
        url: "/api/match/getSportMatchComp",
        data: {
          sport_id: sportId,
        },
      }).then((result) => {
        if (result.status === 200) {
          const res = result.data || {};
          if (res.status === 0) {
            this.MatchComp = res.data?.sport_live_match_comp ?? [];
          }
        }
      });
    },
    inquireMatch() {
      // 直播分类
      post({ url: "/webapi/live/getCategory" }).then((result) => {
        if (result.status === 200) {
          const res = result.data || {};
          if (res.status === 0) {
            this.category = res?.data ?? [];
            // this.formLive.category = first?.id;
          }
        }
      });
    },
    // getMatch() {
    //   this.loading = true;
    //   let data = {
    //     sport_id: this.sportId,
    //   };
    //   post({
    //     url: "/api/match/getSportMatchComp",
    //     data,
    //   }).then(({ data: { data } }) => {
    //     this.pendingMatch = data.sport_live_match_comp || [];
    //     this.loading = false;
    //   });
    // },

    // changeMatch(match_id) {
    //   this.pendingMatch.some((v) => {
    //     if (v.match_id == match_id) {
    //       this.match = v;
    //       return true;
    //     }
    //   });
    // },
    commit() {
      if (this.commitStatus) {
        return;
      }
      this.commitStatus = true;
      this.$refs["ruleForm"].validate((valid) => {
        // console.log("this.ruleForm : ",this.ruleForm);
        if (valid) {
          let data = {
            content: `${this.ruleForm["item1"]}|${this.ruleForm["item2"]} `,
            item_num: 2,
            match_id: this.ruleForm["match_id"],
            match_title: this.ruleForm.session,
            comp: this.ruleForm.match,
            min_bet: this.ruleForm["min_bet"] * 100,
            title: this.ruleForm["title"],
          };
          console.log("data: ", data);
          post({
            url: "/api/guess/createQuestion",
            data,
          })
            .then(({ data: { data, status = "" } }) => {
              // console.log("data: ",data);
              if (status == 0) {
                this.$message({
                  message: "创建成功",
                  type: "success",
                  customClass: "ly-success",
                });
                this.$emit("refresh");
              } else {
                this.$message({
                  message: "创建失败",
                  type: "error",
                  customClass: "ly-error",
                });
              }
              this.close();
            })
            .catch((err) => {
              this.close();
              this.$message({
                message: "创建失败",
                type: "error",
                customClass: "ly-error",
              });
              console.warn("createQuestion err: ", err);
            });
        } else {
          this.commitStatus = false;
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="stylus">
.add-question-dialog-components{
  z-index:1;
  border-radius: 8px;
.title{
	color : #333333;
	font-size : .16rem;
}
  .content{

    .content-btn{
		background: linear-gradient(90deg, #29F19C 0%, #02A1F9 100%);
		border-radius: 5px;
		width : 1.3rem;
		height : 35px;
		color : #ffffff;
		margin : .1rem;
		cursor: pointer;
	}
  }

  .dialog-footer_one>div{
    height: 40px;
    background: #26D99D;
    border-radius: 20px;
	margin: .2rem;
  }

.content-tip{
	color : #3C9CFE;
	margin : .3rem 0rem;
	font-size : .1rem;
}
/deep/{
	@import "../../assets/common-dialog-1.css";
	.el-form-item{
		margin-bottom : 10px;
	}
	.el-input--small .el-input__icon{
		line-height : 40px;
	}
}

}
</style>
